import { useGlobalState } from './GlobalStateProvider'
import useDataFetcher from './useDataFetcher'
import randomString from 'random-string'

const tempPassword = randomString({
  length: 16,
  special: true
})
export default ({ globalState, offer, experienceState }) => {
  const { isAssigned, experience, cobrandingInfo } = experienceState
  const shouldMyKbbFire = !isAssigned && !cobrandingInfo && experience.toLowerCase() === 'kbb'
  let email = shouldMyKbbFire && globalState && globalState.email ? globalState.email.toLowerCase() : null
  //check email
  const [getAccountInfo] = useMyKbbDataFetcher(email && offer && '/mykbb/api/getmykbbaccountinfo/', email)

  let UID = getAccountInfo && getAccountInfo.UID
  const profile = { email: email, firstName: globalState.firstName, lastName: globalState.lastName, zip: globalState.zip }
  const profileData = { profile }

  //if user exists update their account
  const [updateAccount] = useMyKbbDataFetcher(UID && `/mykbb/api/updateaccountinfo?uid=${UID}&objectName=profile`, profileData)

  //register new user if account doesn't exist
  const [registerAccount] = useRegisterAccount(globalState.myKbbChecked && getAccountInfo === null && !UID && profile)
  UID = registerAccount && registerAccount.UID ? registerAccount.UID : UID
  useSaveOffertoMyKbb((updateAccount && updateAccount.statusCode === 200 && UID) || (registerAccount && UID), globalState.zip, offer)
}

const useMyKbbDataFetcher = (url, body) => {
  const {
    globalState: { environment }
  } = useGlobalState()
  const kbbUrl = environment.kbb_Url
  const headers = JSON.stringify({
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    Accept: 'application/json, text/javascript'
  })
  const [responseData] = useDataFetcher(url && kbbUrl + url, true, JSON.stringify(body), headers, 'POST')
  return [responseData]
}

const useRegisterAccount = profile => {
  let apiData = undefined
  if (profile) {
    const { email, firstName, lastName, zip } = profile

    apiData = {
      password: tempPassword,
      profile: {
        email: email || '',
        firstName: firstName || '',
        lastName: lastName || '',
        zip: zip || ''
      },
      data: {
        brands: {
          KBB: true
        },
        kbb: {
          autoCreate: true,
          createSource: 'ICO',
          emailOptIn: true,
          tempPassword
        }
      }
    }
  }
  const url = `/mykbb/api/registeraccount`
  const [response, meta] = useMyKbbDataFetcher(apiData && url, apiData)
  return [response, meta]
}

const useSaveOffertoMyKbb = (uid, zip, offer) => {
  let offerData = undefined
  if (offer) {
    const { offerId, amount, expirationDate: expiredDate, chosenCondition: condition, prospect } = offer

    const {
      mileage,
      options,
      vehicle: { trimId: vehicleId, colorId, engineId, transmissionId, drivetrainId }
    } = prospect

    let combinedOptions =
      options &&
      options.concat([
        {
          optionId: engineId,
          isSelected: true
        },
        {
          optionId: transmissionId,
          isSelected: true
        },
        {
          optionId: drivetrainId,
          isSelected: true
        },
        {
          optionId: colorId,
          isSelected: true
        }
      ])

    combinedOptions =
      combinedOptions &&
      combinedOptions.sort((optionA, optionB) => {
        return optionA.optionId - optionB.optionId
      })

    const sanitizedOptions =
      combinedOptions &&
      combinedOptions
        .filter(option => {
          return option.isSelected === true
        })
        .map(option => {
          return `${option.optionId}|${option.isSelected === true}`
        })
        .join('|')

    offerData = {
      amount,
      condition,
      expiredDate,
      intent: null,
      mileage,
      offerId,
      options: sanitizedOptions,
      priceType: null,
      vehicleId
    }
  }
  const url = uid && offer && `/ico/offer/post/?uid=${uid}&zip=${zip}`

  const [response] = useMyKbbDataFetcher(url && url, offerData)
  return [response]
}
